import store from './store';
import Vue from 'vue';
import App from './App.vue';
import router from './router';
import './config/axios';
import VueToastr2 from 'vue-toastr-2';
import 'vue-toastr-2/dist/vue-toastr-2.min.css';
import vuetify from './plugins/vuetify';

window.toastr = require('toastr');
Vue.config.productionTip = false;

Vue.use(VueToastr2);

export const bus = new Vue();

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app');
